import { createContext, useEffect, useState } from "react";
import { getEngTasks, getEtItem, getEtSchedule } from "../services/EtService";
import { environment } from "../../../environments/environment";
import { LABELS } from "../../../globals/globals";

export const EtItemContext = createContext();

export const EtItemProvider = ({children, open, itemId}) => {
    const [item, setItem] = useState(null);
    const [itemSchedule, setItemSchedule] = useState(null);
    const [itemStatus, setItemStatus] = useState("");

    const [scheduleStatus, setScheduleStatus] = useState("");
    const [refStatus, setRefStatus] = useState("");
    const startEditing = () => setItemStatus(LABELS.EDITION_MODE);
    const startEditSchedule = () => setScheduleStatus(LABELS.EDITION_MODE);
    const startEditRef = () => setRefStatus(LABELS.EDITION_MODE);

    useEffect(()=>{
        if (open === true) {
            getEtItem(itemId).then(response => {
                if (response.data.responseCode === 200) {
                    console.warn("*et item", response.data.load);
                    setItem(response.data.load);
                }
                
            });
            getEtSchedule(itemId).then(response => {
                if (response.data.responseCode === 200) {
                    console.warn("*et item", response.data.load);
                    setItemSchedule(response.data.load);
                }
            });

        }

    },[open, itemId])


    return (
        <EtItemContext.Provider value={{item, itemStatus, startEditing, scheduleStatus, refStatus, startEditSchedule, startEditRef, itemSchedule}}>
            {children}
        </EtItemContext.Provider>
    )

}